module.exports = __webpack_public_path__ + "img/wsh.18bb0c78.png";